<template>
  <div v-if="progress.enabled" class="rounded-xl bg-elevated/60 p-3 ring-1 ring-default">
    <div class="flex items-start gap-2">
      <UIcon
        :name="progress.qualified ? 'i-heroicons-check-badge' : 'i-heroicons-truck'"
        class="mt-0.5 h-5 w-5 shrink-0"
        :class="progress.qualified ? 'text-emerald-500' : 'text-primary-500'"
      />
      <p class="text-sm leading-snug">
        <template v-if="progress.qualified">
          <span class="font-semibold text-emerald-600 dark:text-emerald-400">Felicitări!</span>
          Ai transport <span class="font-semibold">gratuit</span>.
        </template>
        <template v-else>
          Mai adaugă <span class="font-semibold text-highlighted">{{ formatPrice(progress.remaining) }}</span>
          pentru <span class="font-semibold">transport gratuit</span>.
        </template>
      </p>
    </div>
    <div class="mt-2 h-2 overflow-hidden rounded-full bg-muted">
      <div
        class="h-full rounded-full transition-[width] duration-500 ease-out"
        :class="progress.qualified ? 'bg-emerald-500' : 'bg-primary-500'"
        :style="{ width: `${progress.percent}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  subtotal: number
}>()

const { ensureThreshold, progressFor } = useFreeShipping()
const { formatPrice } = useSeo()

const progress = computed(() => progressFor(props.subtotal))

onMounted(() => {
  ensureThreshold()
})
</script>
